import { render, staticRenderFns } from "./SuperChallenge.vue?vue&type=template&id=4489fd83"
import script from "./SuperChallenge.vue?vue&type=script&lang=js"
export * from "./SuperChallenge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports